<template>
  <div :class="[ 'general-container', mainClass ]">
    <div class="general-container__title">
      <div class="general-container__title-picture" />
      <div class="general-container__title-text">
        <span class="general-container__title-main">{{ title }}<span v-if="titlePrecision">{{ titlePrecision }}</span></span>
        <span class="general-container__subtitle">
          {{
            trans('guided_search.general.subtitle', {
              company_name: $companyName,
            })
          }}
        </span>
      </div>
    </div>
    <slot name="content" />
  </div>
</template>

<script>
import translation from '@elements/translation';
import guidedSearchMixin from '../guidedSearchMixin';

export default {
  name: 'BaseStep',
  mixins: [ guidedSearchMixin, translation ],
  props: {
    title: { type: String, required: true },
    titlePrecision: { type: String, default: '' },
    mainClass: { type: String, required: true }, // mainClass is the class for the block inserted there
  },
};
</script>
